export const calcDiffDate = (first, second = new Date().getTime()) => {
    const [datePart, timePart] = first.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes, secondsPart] = timePart.split(':');
    const [seconds, microseconds] = secondsPart.split('.').map(Number);

    const timestampMilliseconds = Date.UTC(year, month - 1, day, hours, minutes, seconds);

    return Math.round((second - timestampMilliseconds) / 60000)
}